module.exports = __webpack_public_path__ + "static/media/011-rhombus-green.7351e107.svg";